import React, { useState } from 'react'
import { withLayouts } from 'react-dx'
import { useLingui } from '@lingui/react/macro'

import PromotionPopups from '../_components/PromotionPopups'
import { promotionPopupsConfig } from '../_components/PromotionPopups/config'

import Footer from './Footer'
import Header from './Header'
import { mainMarginTopIncludingHeaderCls } from './Header/constants'
import SideBar from './SideBar'
import { useLayoutStore } from './store'

import type { DefaultLayoutProps, DefaultMainProps } from '@/layouts/type'

import { emptyObject } from '@/constants/react'
import { SitePromotionPopupsProvider } from '@/contexts/SiteSpecificContext/popups/Provider'
import { useInWhichPage } from '@/hooks/useInWhichPage'


import { useEffect } from 'react';
import { tw } from 'tagged-classnames-free';
/** 带 Header/Footer 的 Layout */
function DefaultLayout(props: DefaultLayoutProps) {
  const {
    minHScreen = true,
    header,
    main = emptyObject as DefaultMainProps,
    footer,
    sideBar,
    children,
    locales,
  } = props
  const { includingHeader = false, ...restMainProps } = main
  const { inCreatePage, inLibraryPage, inHomePage } = useInWhichPage()

  const [darkMode, setDarkMode] = useState(false)
  const { setShowSidebar } = useLayoutStore()
  const { t } = useLingui()

  useEffect(() => {
    window.getDarkMode = () => darkMode
    window.setDarkMode = setDarkMode
    window.toggleDarkMode = () => {
      setDarkMode(!darkMode)
    }
  }, [darkMode, setDarkMode])

  useEffect(() => {
    setShowSidebar(!!sideBar) // 存储侧边栏展示状态供global player判断弹出detail的宽度是否全屏
  }, [])

  // useCookieConsent({
  //   title: t`Cookies on Our Site`,
  //   description: t`We use cookies to give you the best possible experience on our website. By continuing to browse this site, you give consent for cookies to be used.`,
  //   preferencesTitle: t`Set up`,
  //   acceptAllBtn: t`Accept All Cookies`,
  //   showPreferencesBtn: t`Cookie Settings`,
  //   layout: 'box',
  //   position: 'middle center',
  //   savePreferencesBtn: t`Save & Accept`,
  //   sections: [
  //     {
  //       title: t`Cookie Settings`,
  //       description: t`Choose what types of cookies you accept.`,
  //     },
  //     {
  //       title: t`Fundamental Cookies`,
  //       description: t`Fundamental cookies are crucial for the website and facilitate essential tasks such as secure log-ins, user session maintenance, and management of website traffic. Without these cookies, our website may not function as intended or provide necessary security safeguards.`,
  //       linkedCategory: 'necessary',
  //     },
  //     {
  //       title: t`Insight Cookies`,
  //       description: t`Insight cookies are key to helping us comprehend how visitors engage with our website. These cookies monitor various metrics such as visitor counts, bounce rates, and traffic sources.`,
  //       linkedCategory: 'advertisement',
  //     },
  //     {
  //       title: t`Personalization Cookies`,
  //       description: t`These cookies track how you interact with the website content, our social media and advertisements to understand your interests and preferences, making your experience on our website more targeted and relevant.`,
  //       linkedCategory: 'analytics',
  //     },
  //     {
  //       title: t`Functional Cookies`,
  //       description: t`Functional cookies significantly enhance the user experience on our website by enabling a range of personalized features. These cookies remember the choices you've made, and provide customized functionality in response.`,
  //       linkedCategory: 'functional',
  //     },
  //   ],
  // })

  const mainDom = (
    <main
      {...restMainProps}
      className={tw`
        ${minHScreen && 'flex-1'}
        ${main?.className}
        ${includingHeader && mainMarginTopIncludingHeaderCls}
        z-0
      `}
    >
      {children}
    </main>
  )

  const seoH1 = [
    {
      title: t`Music Library`,
      match: inLibraryPage,
    },
  ]
    .filter(({ match }) => match)
    .map(({ title }) => title)[0]

  return (
    <>
      {seoH1 ? <h1 className='sr-only'>{seoH1}</h1> : null}
      <PromotionPopups />
      <div className='flex h-screen'>
        {sideBar ? <SideBar {...sideBar} /> : null}
        <div
          data-scroll-container
          className='scrollbar z-1 relative flex min-w-0 flex-1 flex-col overflow-y-auto scroll-smooth'
        >
          {header !== null ? <Header {...header} locales={locales} /> : null}
          {mainDom}
          {footer !== null ? <Footer {...footer} locales={locales} /> : null}
        </div>
      </div>
    </>
  )
}

const LayoutsDefaultLayout = withLayouts(DefaultLayout, [
  (props) => {
    return (
      <SitePromotionPopupsProvider {...props} config={promotionPopupsConfig} />
    )
  },
])

export default LayoutsDefaultLayout
